export default __webpack_public_path__ + "static/media/sprint.5ca98628.png";